import React from "react";
import styled from "styled-components";
import { injectIntl } from "react-intl";
import SubLabel from "./SubLabel";

const SubTextWrapper = styled.div`
  display: flex;
  padding: 5px 0;
  min-height: 24px;
  align-items: center;
`;

const InnerWrapper = styled.div`
  display: flex;
  min-height: 18px;
  align-items: center;
`;

const ErrorIcon = styled.i`
  margin-right: 6px;
  color: ${(p) => p.theme.colors.text.danger};
`;

const ErrorText = styled.p`
  margin-bottom: 0;
  font-size: 12px;
  color: ${(p) => p.theme.colors.text.danger};
`;

const ValidationBar = injectIntl(
  ({ error, subLabel, disableValidation = false, intl, className }) => {
    if (disableValidation && !subLabel) {
      return <SubTextWrapper />;
    }

    if (typeof error !== "string") {
      return (
        <SubTextWrapper>
          {subLabel && (
            <InnerWrapper tabIndex="0">
              <SubLabel className={`sp-sub-label ${className}`}>
                {subLabel}
              </SubLabel>
            </InnerWrapper>
          )}
        </SubTextWrapper>
      );
    }

    return (
      <SubTextWrapper className={`sp-validation-bar ${className}`}>
        <div>
          {subLabel && (
            <InnerWrapper tabIndex="0">
              <SubLabel className="sp-sub-label">{subLabel}</SubLabel>
            </InnerWrapper>
          )}
          {disableValidation === false && (
            <InnerWrapper tabIndex="0">
              <ErrorIcon className="fa-light fa-circle-exclamation" />
              <ErrorText>
                {error && intl.formatMessage({ id: error })}
              </ErrorText>
            </InnerWrapper>
          )}
        </div>
      </SubTextWrapper>
    );
  }
);

export default ValidationBar;
